import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTextField from '../../../FormFields/FormTextField';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTitle from '../../../FormFields/FormTitle';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { HR } from '../../../formQuestionsEnum';

FacilityUnionForm.propTypes = {
  permissions: PropTypes.object,
};

export default function FacilityUnionForm({ permissions }) {
  const { watch } = useFormContext();
  const isFacilityUnion = watch(HR.IS_FACILITY_UNION.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    HR.IS_FACILITY_UNION.id,
    HR.CBA_FILE.id,
    HR.ARE_BENEFITS_FROM_UNION.id,
    HR.WAIT_PERIOD.id,
    HR.BENEFIT_PLANS_FILE.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Facility Union
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {HR.IS_FACILITY_UNION.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Is this facility a union?' }} />
              <FormButtonOptions
                fieldName={HR.IS_FACILITY_UNION.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.IS_FACILITY_UNION.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}

          {isFacilityUnion === true && (
            <>
              {HR.CBA_FILE.id in permissions && (
                <Grid item xs={12}>
                  <FormTitle fieldAttributes={{ questionTitle: 'Copy of CBA', fieldType: 'file' }} />
                  <FormFileDrop
                    fieldName={HR.CBA_FILE.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.CBA_FILE.id],
                      fileTypeId: FILE_TYPES.CBA,
                    }}
                  />
                </Grid>
              )}
              {HR.ARE_BENEFITS_FROM_UNION.id in permissions && (
                <Grid item xs={12}>
                  <FieldContainer>
                    <FormTitle fieldAttributes={{ questionTitle: 'Are benefits through the union?' }} />
                    <FormButtonOptions
                      fieldName={HR.ARE_BENEFITS_FROM_UNION.fieldName}
                      fieldAttributes={{
                        isEditable: permissions[HR.ARE_BENEFITS_FROM_UNION.id],
                        options: [
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ],
                      }}
                    />
                  </FieldContainer>
                </Grid>
              )}
            </>
          )}

          {HR.WAIT_PERIOD.id in permissions && (
            <Grid item xs={4}>
              <FormTitle fieldAttributes={{ questionTitle: 'Wait period' }} />
              <FormTextField
                fieldName={HR.WAIT_PERIOD.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.WAIT_PERIOD.id],
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}

          {HR.BENEFIT_PLANS_FILE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle
                fieldAttributes={{
                  questionTitle: 'Summary of benefit plans',
                  fieldType: 'file',
                  information:
                    'Summary of benefit plans: medical, dental, vision, pharmacy, group life, supplemental life, and supplemental disability programs',
                }}
              />
              <FormFileDrop
                fieldName={HR.BENEFIT_PLANS_FILE.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.BENEFIT_PLANS_FILE.id],
                  fileTypeId: FILE_TYPES.BENEFIT_PLANS,
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
